import React, { useEffect, useRef } from 'react';
import { getFacePos, getFaceRot } from './helpers';
import GreenScreenedVid from './GreenScreenedVid';
import * as THREE from 'three';

const VideoFace = ({
	src,
	faceName,
	autoPlay = true,
	loop = true,
	scene,
	keyColor,
	smoothness,
	similarity,
	spill,
}) => {
	const meshRef = useRef(null);
	const videoRef = useRef(null);
	const videoTextureRef = useRef(null);

	useEffect(() => {
		setup();
		return teardown;
	}, []);

	const setup = () => {
		const pos = getFacePos(faceName);
		const rot = getFaceRot(faceName);

		meshRef.current = GreenScreenedVid(
			null,
			pos,
			rot,
			keyColor,
			similarity,
			smoothness,
			spill,
		);

		videoRef.current = createVidDom(src);

		if (autoPlay) {
			triggerVideo();
		}
		document.addEventListener('trigger_gss', triggerVideo);
	};

	const triggerVideo = () => {
		videoRef.current
			.play()
			.then(() => {})
			.catch((e) => {
				console.warn(e);
			});
	};

	const teardown = () => {
		meshRef.current?.material.dispose();
		meshRef.current?.geometry.dispose();
		scene.remove(meshRef.current);

		videoRef.current.paused === false && videoRef.current.pause();
		videoRef.current.removeEventListener('playing', onVideoPlaying);
		document.removeEventListener('trigger_gss', triggerVideo);
		videoRef.current.remove();
	};

	// helps reduce video stuttering
	const updateTexture = (texture) => {
		videoRef.current.requestVideoFrameCallback(updateTexture);
		videoTextureRef.current.needsUpdate = true;
	};

	const onVideoPlaying = () => {
		const texture = new THREE.VideoTexture(videoRef.current);
		texture.colorSpace = THREE.SRGBColorSpace;
		if (keyColor) {
			meshRef.current.material.uniforms.tex.value = texture;
		} else {
			meshRef.current.material.map = texture;
			meshRef.current.material.needsUpdate = true;
		}
		texture.colorSpace = THREE.SRGBColorSpace;

		meshRef.current.renderOrder = 2;
		scene.add(meshRef.current);
		videoTextureRef.current = texture;

		updateTexture(texture);
	};

	const createVidDom = (src) => {
		const video = document.createElement('video');

		video.addEventListener('playing', onVideoPlaying);

		video.src = src;
		video.setAttribute('webkit-playsinline', '');
		video.crossOrigin = 'anonymous';
		video.setAttribute('playsinline', '');
		if (loop) {
			video.setAttribute('loop', true);
		} else {
			video.addEventListener('ended', () => {
				video.currentTime = 0;
			});
		}
		video.muted = true;

		return video;
	};

	return <></>;
};

export default VideoFace;
